import { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';

import DatePicker from '@alltrails/shared/components/DatePicker';

class GiftEditForm extends Component {
  constructor(props) {
    super(props);
    const gift = this.props.gift;
    // convert ISO timestamp into a useful JS date here
    gift.deliveryDate = gift.metadata.deliveryDate ? new Date(gift.metadata.deliveryDate) : null;
    this.state = { gift, allowSave: false };
  }

  handleTextChange = (e, key) => {
    const gift = { ...this.state.gift };
    gift[key] = e.target.value;
    this.setState({ gift, allowSave: true });
  };

  handleDateChange = date => {
    const gift = { ...this.state.gift };
    gift.deliveryDate = date;
    this.setState({ gift, allowSave: true });
  };

  render() {
    const { gift } = this.state;
    return (
      <div className={styles.couponCard}>
        <h4>{`Code: ${gift.code}`}</h4>
        <h4>{`Plan Type: ${gift.planType}`}</h4>
        <h4>{`Delivery date: ${gift.deliveryDate}`}</h4>
        <DatePicker onChange={this.handleDateChange} date={gift.deliveryDate} disableFuture={false} />
        <h4>{`Delivery Timezone: ${gift.metadata.timezoneIdentifier}`}</h4>
        <h4>Sender:</h4>
        <input className={styles.giftInputs} value={gift.senderName} onChange={e => this.handleTextChange(e, 'senderName')} />
        <h4>Sender email:</h4>
        <input className={styles.giftInputs} value={gift.senderEmail} onChange={e => this.handleTextChange(e, 'senderEmail')} />
        <h4>Receipient:</h4>
        <input className={styles.giftInputs} value={gift.recipientName} onChange={e => this.handleTextChange(e, 'recipientName')} />
        <h4>Receipient email:</h4>
        <input className={styles.giftInputs} value={gift.recipientEmail} onChange={e => this.handleTextChange(e, 'recipientEmail')} />
        <h4>Message:</h4>
        <textarea value={gift.message} onChange={e => this.handleTextChange(e, 'message')} />
        <button className={styles.actionButton} onClick={this.props.handleEditGiftClick}>Cancel</button>
        {this.state.allowSave && (
          <button className={styles.actionButton} onClick={() => this.props.handleSaveGiftClick(this.state.gift)}>
            Save
          </button>
        )}
      </div>
    );
  };
};

GiftEditForm.propTypes = {
  gift: PropTypes.object.isRequired,
  handleEditGiftClick: PropTypes.func.isRequired,
  handleSaveGiftClick: PropTypes.func.isRequired
};

GiftEditForm.defaultProps = {};

export default GiftEditForm;
